import type { ResourceConfig } from "../types";

export const systemIntegrationConfig = {
  displayName: "系统集成设置",
  category: "system",
  permissions: {
    "read:all": {
      label: "查看系统集成设置",
      description: "可以查看第三方集成的脱敏配置状态",
    },
    "write:all": {
      label: "管理系统集成设置",
      description: "可以更新和验证第三方集成配置",
    },
  },
  navigation: {
    path: "/system-settings",
    label: "系统设置",
    icon: "Settings" as const,
    requiredPermissions: ["read:all"] as const,
    group: "management",
    order: 90,
  },
} satisfies ResourceConfig;
